import { CustomRouterStateSerializer, RouterStateUrl } from './router.state';

export {
    CustomRouterStateSerializer,
    RouterStateUrl
};